import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './Categories1.css';

function MainCategories({categories}) {

    const [categorias, setCategorias] = useState([]);

    /*useEffect(() => {
        
        if (categories.length > 0) {
            
            groupByFour(categories);
        }
            
    }, [categories]);*/

    useEffect(() => {
        if (categories.length > 0) {

            groupByFour(categories);
        }
    }, [categories]);

    function groupByFour(arr) {

        /*const resultado = [];

        for (let i = 0; i < arr.length; i += 4) {
            resultado.push(arr.slice(i, i + 4));
        }*/

        setCategorias(arr)
    }

    const goToSubcategories = (idcategory) => {
        //window.open('/category_products/'+idcategory);
        window.location.href = '/subcategories/'+idcategory;
    }

    return (
        <div>
            <div className="section-043">
                <div className="container">
                    <div className="kreen-heading style-01">
                        <div className="heading-inner">
                            <h3 className="title">
                                Categorías</h3>
                            {
                                /*
                                <div className="subtitle">
                                    Lorem ipsum dolor sit amet consectetur adipiscing elit erat vehicula ad, mollis viverra
                                    vulputate
                                </div>
                                */
                            }
                        </div>
                    </div>
                    <div className="kreen-categories  style-02">
                        <div className='row'>
                            
                            {
                                categorias.map( (catg, index) => {
                                    return (
                                        <div className="col-md-3" key={catg.dessCategoryId}>    
                                            <div className="categories-item rows-space-0 post-740 page type-page status-publish hentry">
                                                <div onClick={()=>goToSubcategories(catg.dessCategoryId)} className="categories-inner" style={{cursor:'pointer'}}>
                                                    <figure className="categories-thumb">
                                                        
                                                            <img src={catg.url_img_category}
                                                                className="img-responsive attachment-370x370 size-370x370" alt="img"
                                                                width="370"
                                                                height="370" />
                                                    </figure>
                                                    <h3 className="title">
                                                        {
                                                            /*<a href={`/category_products/${catg.dessCategoryId}`} tabindex="-1">
                                                            {catg.name_category} </a>*/
                                                        }
                                                        <b>{catg.name_category} </b>
                                                    </h3>
                                                </div>
                                            </div>
                                            <br />
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default MainCategories;